import { PlotValue } from 'types';

export function reducePlotValues(
  arr: PlotValue[],
  start: number,
  range: number,
  property: 'value' | 'bumps' | 'spots' | 'priceDrops',
) {
  return arr
    .slice(start, start + range)
    .reduce((acc, y: PlotValue) => acc + y[property], 0);
}

export function combinePlotValues(arr: PlotValue[], range: number) {
  const updatedPlotValues: PlotValue[] = [];
  for (let i = 0; i < arr.length; i += range) {
    updatedPlotValues.push({
      date: arr[i].date,
      ...(arr[i + range - 1] && {
        endDate: arr[i + range - 1]?.date,
      }),
      value: reducePlotValues(arr, i, range, 'value'),
      bumps: reducePlotValues(arr, i, range, 'bumps'),
      spots: reducePlotValues(arr, i, range, 'spots'),
      priceDrops: reducePlotValues(arr, i, range, 'priceDrops'),
    });
  }
  return updatedPlotValues;
}
